export const SET_STATE = 'checkoutPage/paymentProviders/paymentProviderTripX/SET_STATE';
export const SET_FETCHING = 'checkoutPage/paymentProviders/paymentProviderTripX/SET_FETCHING';
export const RESET_STATE = 'checkoutPage/paymentProviders/paymentProviderTripX/RESET_STATE';
